var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AlertDangerColorful: () => AlertDangerColorful,
  AlertExclamation: () => AlertExclamation,
  AlertExclamationColorful: () => AlertExclamationColorful,
  AlertExclamationMini: () => AlertExclamationMini,
  AlertSuccessCircle: () => AlertSuccessCircle,
  Analytics: () => Analytics,
  ArrowClockwise: () => ArrowClockwise,
  ArrowCounterClockwise: () => ArrowCounterClockwise,
  ArrowLeft: () => ArrowLeft,
  ArrowRight: () => ArrowRight,
  Assign: () => Assign,
  Bell: () => Bell,
  BlockCircle: () => BlockCircle,
  Calendar: () => Calendar,
  Checkmark: () => Checkmark,
  ChevronDown: () => ChevronDown,
  ChevronDownMini: () => ChevronDownMini,
  ChevronLeft: () => ChevronLeft,
  ChevronLeftMini: () => ChevronLeftMini,
  ChevronRight: () => ChevronRight,
  ChevronRightMini: () => ChevronRightMini,
  ChevronSort: () => ChevronSort,
  ChevronUp: () => ChevronUp,
  ChevronUpDown: () => ChevronUpDown,
  ChevronUpMini: () => ChevronUpMini,
  Cloud: () => Cloud,
  CloudDownload: () => CloudDownload,
  CloudDownloadFilled: () => CloudDownloadFilled,
  CloudFilled: () => CloudFilled,
  CloudUpload: () => CloudUpload,
  CloudUploadFilled: () => CloudUploadFilled,
  Cog: () => Cog,
  CogDouble: () => CogDouble,
  Copy: () => Copy,
  Cross: () => Cross,
  CrossCircle: () => CrossCircle,
  Documentation: () => Documentation,
  Download: () => Download,
  Draggable: () => Draggable,
  Duplicate: () => Duplicate,
  EyeClose: () => EyeClose,
  EyeOpen: () => EyeOpen,
  Feedback: () => Feedback,
  File: () => File,
  Filter: () => Filter,
  HintFeedback: () => HintFeedback,
  HintInner: () => HintInner,
  Key: () => Key,
  ListDot: () => ListDot,
  Lock: () => Lock,
  Logout: () => Logout,
  Mail: () => Mail,
  Menu: () => Menu,
  Message: () => Message,
  Minimize: () => Minimize,
  Minus: () => Minus,
  Module: () => Module,
  More: () => More,
  Move: () => Move,
  NewTab: () => NewTab,
  Pencil: () => Pencil,
  Pin: () => Pin,
  Plus: () => Plus,
  PlusCircle: () => PlusCircle,
  PlusFolder: () => PlusFolder,
  PowerOff: () => PowerOff,
  Profile: () => Profile,
  ResizeAngle: () => ResizeAngle,
  Search: () => Search,
  Share: () => Share,
  Spinner: () => Spinner,
  Star: () => Star,
  SuccessColorful: () => SuccessColorful,
  Switcher: () => Switcher,
  Ticket: () => Ticket,
  Tile: () => Tile,
  Transaction: () => Transaction,
  TransactionDouble: () => TransactionDouble,
  Trash: () => Trash,
  useIsXsollaIcon: () => useIsXsollaIcon
});
module.exports = __toCommonJS(src_exports);

// src/components/AlertDangerColorful.tsx
var import_react2 = __toESM(require("react"));

// src/components/_IconBase.tsx
var import_react = __toESM(require("react"));
var DEFAULT_SIZE = 24;
var DEFAULT_COLOR = "currentColor";
var IconBase = ({ size, color, viewBox, renderPath, ...rest }) => /* @__PURE__ */ import_react.default.createElement("svg", {
  ...rest,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: viewBox != null ? viewBox : "0 0 24 24",
  width: size != null ? size : DEFAULT_SIZE,
  height: size != null ? size : DEFAULT_SIZE,
  fill: "none"
}, renderPath(color != null ? color : DEFAULT_COLOR));

// src/components/AlertDangerColorful.tsx
var AlertDangerColorful = (props) => /* @__PURE__ */ import_react2.default.createElement(IconBase, {
  ...props,
  renderPath: () => /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null, /* @__PURE__ */ import_react2.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1248 2.48973C11.5238 1.83676 12.4762 1.83676 12.8751 2.48973L23.8493 20.4513C24.2644 21.1306 23.7729 22 22.9741 22H1.02585C0.227036 22 -0.264323 21.1306 0.150651 20.4513L11.1248 2.48973Z",
    fill: "#EB002F"
  }), /* @__PURE__ */ import_react2.default.createElement("path", {
    d: "M11.1062 8.82394C11.0867 8.29974 11.4925 7.86381 12 7.86381C12.5075 7.86381 12.9133 8.29974 12.8939 8.82394L12.6197 16.2044H11.3804L11.1062 8.82394Z",
    fill: "white"
  }), /* @__PURE__ */ import_react2.default.createElement("path", {
    d: "M11.3804 18.7534V17.4722H12.6197V18.7534H11.3804Z",
    fill: "white"
  }))
});

// src/components/AlertExclamation.tsx
var import_react3 = __toESM(require("react"));
var AlertExclamation = (props) => /* @__PURE__ */ import_react3.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react3.default.createElement(import_react3.default.Fragment, null, /* @__PURE__ */ import_react3.default.createElement("path", {
    opacity: "0.12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1425 2.42915C11.5309 1.78182 12.4691 1.78182 12.8575 2.42915L23.0913 19.4855C23.4912 20.152 23.0111 21 22.2338 21H1.76619C0.988895 21 0.508783 20.152 0.908698 19.4855L11.1425 2.42915Z",
    fill: color
  }), /* @__PURE__ */ import_react3.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V15.0208H11V9ZM11 18V16H13V18H11Z",
    fill: color
  }))
});

// src/components/AlertExclamationMini.tsx
var import_react4 = __toESM(require("react"));
var AlertExclamationMini = (props) => /* @__PURE__ */ import_react4.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react4.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V14.0208H11V8ZM11 17V15H13V17H11Z",
    fill: color
  })
});

// src/components/AlertExclamationColorful.tsx
var import_react5 = __toESM(require("react"));
var AlertExclamationColorful = (props) => /* @__PURE__ */ import_react5.default.createElement(IconBase, {
  ...props,
  renderPath: () => /* @__PURE__ */ import_react5.default.createElement(import_react5.default.Fragment, null, /* @__PURE__ */ import_react5.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1248 2.48973C11.5238 1.83676 12.4762 1.83676 12.8751 2.48973L23.8493 20.4513C24.2644 21.1306 23.7729 22 22.9741 22H1.02585C0.227036 22 -0.264323 21.1306 0.150651 20.4513L11.1248 2.48973Z",
    fill: "#FFC500"
  }), /* @__PURE__ */ import_react5.default.createElement("path", {
    d: "M11.1062 8.82394C11.0867 8.29974 11.4925 7.86381 12 7.86381C12.5075 7.86381 12.9133 8.29974 12.8939 8.82394L12.6197 16.2044H11.3804L11.1062 8.82394Z",
    fill: "#00244D"
  }), /* @__PURE__ */ import_react5.default.createElement("path", {
    d: "M11.3804 18.7534V17.4722H12.6197V18.7534H11.3804Z",
    fill: "#00244D"
  }))
});

// src/components/AlertSuccessCircle.tsx
var import_react6 = __toESM(require("react"));
var AlertSuccessCircle = (props) => /* @__PURE__ */ import_react6.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react6.default.createElement(import_react6.default.Fragment, null, /* @__PURE__ */ import_react6.default.createElement("path", {
    opacity: "0.12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: color
  }), /* @__PURE__ */ import_react6.default.createElement("path", {
    d: "M16.2561 8.27123C16.6034 7.91559 17.1732 7.90881 17.5288 8.25607C17.8844 8.60334 17.8912 9.17314 17.544 9.52878L10.7838 16.4519C10.4074 16.8373 9.7789 16.808 9.44009 16.3891L7.20027 13.6198C6.88769 13.2334 6.94758 12.6667 7.33405 12.3541C7.72051 12.0415 8.28721 12.1014 8.59979 12.4879L10.2031 14.4701L16.2561 8.27123Z",
    fill: color
  }))
});

// src/components/Analytics.tsx
var import_react7 = __toESM(require("react"));
var Analytics = (props) => /* @__PURE__ */ import_react7.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react7.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5H18C19.1046 5 20 5.89543 20 7V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V7C4 5.89543 4.89543 5 6 5ZM6 7V17H18V7H6ZM13 8H11V16H13V8ZM14 11H16V16H14V11ZM10 13H8V16H10V13Z",
    fill: color
  })
});

// src/components/ArrowClockwise.tsx
var import_react8 = __toESM(require("react"));
var ArrowClockwise = (props) => /* @__PURE__ */ import_react8.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react8.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4L6.34315 6.34315C7.79086 4.89543 9.79086 4 12 4C15.7277 4 18.8599 6.54955 19.748 10H17.6586C16.8349 7.66962 14.6124 6 12 6C10.3431 6 8.84315 6.67157 7.75736 7.75736L10 10H6.34141H4.25203H4V4ZM4.25203 14C5.14012 17.4505 8.27232 20 12 20C14.2091 20 16.2091 19.1046 17.6569 17.6569L20 20V14H19.748H17.6586H14L16.2426 16.2426C15.1569 17.3284 13.6569 18 12 18C9.38756 18 7.16508 16.3304 6.34141 14H4.25203Z",
    fill: color
  })
});

// src/components/ArrowCounterClockwise.tsx
var import_react9 = __toESM(require("react"));
var ArrowCounterClockwise = (props) => /* @__PURE__ */ import_react9.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react9.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4L6.34315 6.34315C7.79086 4.89543 9.79086 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C8.27232 20 5.14012 17.4505 4.25203 14H6.34141C7.16508 16.3304 9.38756 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C10.3431 6 8.84315 6.67157 7.75736 7.75736L10 10H6.34141H4.25203H4V4ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
    fill: color
  })
});

// src/components/ArrowLeft.tsx
var import_react10 = __toESM(require("react"));
var ArrowLeft = (props) => /* @__PURE__ */ import_react10.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react10.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5837 5.26742C11.9374 5.62399 11.9374 6.20209 11.5837 6.55866L7.19268 10.9855H18.9937C19.5495 10.9855 20 11.4397 20 12C20 12.5603 19.5495 13.0145 18.9937 13.0145H7.19268L11.5837 17.4413C11.9374 17.7979 11.9374 18.376 11.5837 18.7326C11.2301 19.0891 10.6566 19.0891 10.303 18.7326L4.26528 12.6456C3.91157 12.289 3.91157 11.711 4.26528 11.3544L10.303 5.26742C10.6566 4.91086 11.2301 4.91086 11.5837 5.26742Z",
    fill: color
  })
});

// src/components/ArrowRight.tsx
var import_react11 = __toESM(require("react"));
var ArrowRight = (props) => /* @__PURE__ */ import_react11.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react11.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4163 5.26742C12.0626 5.62399 12.0626 6.20209 12.4163 6.55866L16.8073 10.9855H5.00629C4.45053 10.9855 4 11.4397 4 12C4 12.5603 4.45053 13.0145 5.00629 13.0145H16.8073L12.4163 17.4413C12.0626 17.7979 12.0626 18.376 12.4163 18.7326C12.7699 19.0891 13.3434 19.0891 13.697 18.7326L19.7347 12.6456C20.0884 12.289 20.0884 11.711 19.7347 11.3544L13.697 5.26742C13.3434 4.91086 12.7699 4.91086 12.4163 5.26742Z",
    fill: color
  })
});

// src/components/Assign.tsx
var import_react12 = __toESM(require("react"));
var Assign = (props) => /* @__PURE__ */ import_react12.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react12.default.createElement(import_react12.default.Fragment, null, /* @__PURE__ */ import_react12.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.652 16.3655C20.1039 17.9886 17.9201 19 15.5 19C13.08 19 10.8962 17.9886 9.34814 16.3655C9.97314 14.9712 11.3732 14 13 14H18C19.6269 14 21.027 14.9712 21.652 16.3655ZM15.5 5C17.4445 5 19 6.55556 19 8.5C19 10.4444 17.4445 12 15.5 12C13.5556 12 12 10.4444 12 8.5C12 6.55556 13.5556 5 15.5 5Z",
    fill: color
  }), /* @__PURE__ */ import_react12.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8C5.44772 8 5 8.44772 5 9V11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H5V15C5 15.5523 5.44772 16 6 16C6.55228 16 7 15.5523 7 15V13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11H7V9C7 8.44772 6.55228 8 6 8Z",
    fill: color
  }))
});

// src/components/Bell.tsx
var import_react13 = __toESM(require("react"));
var Bell = (props) => /* @__PURE__ */ import_react13.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react13.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8667 5C10.8667 4.44772 11.3144 4 11.8667 4H12.1333C12.6856 4 13.1333 4.44772 13.1333 5V5.94346C15.7591 6.49172 17.75 8.93342 17.75 11.8099V15.3653C17.75 16.5503 18.8573 16.6244 18.8573 16.6244L19.2581 16.7315C19.6956 16.8484 20 17.2448 20 17.6976V18.5577C20 18.7786 19.8209 18.9577 19.6 18.9577H4.4C4.17909 18.9577 4 18.7786 4 18.5577V17.6976C4 17.2448 4.30437 16.8484 4.74192 16.7315L5.14275 16.6244C6.28575 16.6244 6.25 15.3653 6.25 15.3653L6.28675 11.6987C6.28675 8.97622 8.2595 6.52316 10.8667 5.95291V5ZM14.4286 19.6297C14.4286 20.9259 13.3425 22 12 22C10.6575 22 9.57139 20.9259 9.57139 19.6297H14.4286Z",
    fill: color
  })
});

// src/components/BlockCircle.tsx
var import_react14 = __toESM(require("react"));
var BlockCircle = (props) => /* @__PURE__ */ import_react14.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react14.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2C15.4242 18.2 18.2 15.4242 18.2 12C18.2 10.6125 17.7443 9.33153 16.9743 8.2985L8.2985 16.9743C9.33153 17.7443 10.6125 18.2 12 18.2ZM7.02571 15.7015L15.7015 7.02571C14.6685 6.25575 13.3875 5.8 12 5.8C8.57583 5.8 5.8 8.57583 5.8 12C5.8 13.3875 6.25575 14.6685 7.02571 15.7015Z",
    fill: color
  })
});

// src/components/Calendar.tsx
var import_react15 = __toESM(require("react"));
var Calendar = (props) => /* @__PURE__ */ import_react15.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react15.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4H7V5H6C4.89543 5 4 5.89543 4 7V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V7C20 5.89543 19.1046 5 18 5H17V4H15V5H9V4ZM6 9V17H18V9H6ZM16 12H13V15H16V12Z",
    fill: color
  })
});

// src/components/Checkmark.tsx
var import_react16 = __toESM(require("react"));
var Checkmark = (props) => /* @__PURE__ */ import_react16.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react16.default.createElement("path", {
    d: "M18.7841 5.30182C19.1697 4.90643 19.8028 4.89849 20.1982 5.28408C20.5936 5.66968 20.6015 6.3028 20.216 6.69819L9.95124 17.1982C9.53311 17.6269 8.83444 17.5945 8.45782 17.1289L5.22252 13.1289C4.87521 12.6995 4.94176 12.0698 5.37116 11.7225C5.80057 11.3752 6.43023 11.4417 6.77754 11.8711L9.30513 13.9961L18.7841 5.30182Z",
    fill: color
  })
});

// src/components/ChevronDown.tsx
var import_react17 = __toESM(require("react"));
var ChevronDown = (props) => /* @__PURE__ */ import_react17.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react17.default.createElement("path", {
    d: "M6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289C4.90237 8.68342 4.90237 9.3166 5.29289 9.7071L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L18.7071 9.7071C19.0976 9.3166 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L12 13.5858L6.70711 8.29289Z",
    fill: color
  })
});

// src/components/ChevronDownMini.tsx
var import_react18 = __toESM(require("react"));
var ChevronDownMini = (props) => /* @__PURE__ */ import_react18.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react18.default.createElement("path", {
    d: "M15.2049 9.80512C15.4783 9.53176 15.9215 9.53176 16.1949 9.80512C16.4682 10.0785 16.4682 10.5217 16.1949 10.7951L12.1949 14.7951C11.9215 15.0684 11.4783 15.0684 11.2049 14.7951L7.20493 10.7951C6.93156 10.5217 6.93156 10.0785 7.20493 9.80512C7.47829 9.53176 7.92151 9.53176 8.19488 9.80512L11.6999 13.3101L15.2049 9.80512Z",
    fill: color
  })
});

// src/components/ChevronLeft.tsx
var import_react19 = __toESM(require("react"));
var ChevronLeft = (props) => /* @__PURE__ */ import_react19.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react19.default.createElement("path", {
    d: "M14.7071 6.70711C15.0976 6.31658 15.0976 5.68342 14.7071 5.29289C14.3166 4.90237 13.6834 4.90237 13.2929 5.29289L7.2929 11.2929C6.9024 11.6834 6.9024 12.3166 7.2929 12.7071L13.2929 18.7071C13.6834 19.0976 14.3166 19.0976 14.7071 18.7071C15.0976 18.3166 15.0976 17.6834 14.7071 17.2929L9.4142 12L14.7071 6.70711Z",
    fill: color
  })
});

// src/components/ChevronLeftMini.tsx
var import_react20 = __toESM(require("react"));
var ChevronLeftMini = (props) => /* @__PURE__ */ import_react20.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react20.default.createElement("path", {
    d: "M14.1949 15.2049C14.4682 15.4783 14.4682 15.9215 14.1949 16.1949C13.9215 16.4682 13.4783 16.4682 13.2049 16.1949L9.20493 12.1949C8.93156 11.9215 8.93156 11.4783 9.20493 11.2049L13.2049 7.20493C13.4783 6.93156 13.9215 6.93156 14.1949 7.20493C14.4682 7.47829 14.4682 7.92151 14.1949 8.19488L10.6899 11.6999L14.1949 15.2049Z",
    fill: color
  })
});

// src/components/ChevronRight.tsx
var import_react21 = __toESM(require("react"));
var ChevronRight = (props) => /* @__PURE__ */ import_react21.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react21.default.createElement("path", {
    d: "M8.293 6.707a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707z",
    fill: color
  })
});

// src/components/ChevronRightMini.tsx
var import_react22 = __toESM(require("react"));
var ChevronRightMini = (props) => /* @__PURE__ */ import_react22.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react22.default.createElement("path", {
    d: "M10.205 8.19497C9.93166 7.92161 9.93166 7.47839 10.205 7.20503C10.4784 6.93166 10.9216 6.93166 11.195 7.20503L15.195 11.205C15.4683 11.4784 15.4683 11.9216 15.195 12.195L11.195 16.195C10.9216 16.4683 10.4784 16.4683 10.205 16.195C9.93166 15.9216 9.93166 15.4784 10.205 15.205L13.7101 11.7L10.205 8.19497Z",
    fill: color
  })
});

// src/components/ChevronSort.tsx
var import_react23 = __toESM(require("react"));
var ChevronSort = (props) => /* @__PURE__ */ import_react23.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react23.default.createElement(import_react23.default.Fragment, null, /* @__PURE__ */ import_react23.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16L15 13H9L12 16Z",
    fill: color
  }), /* @__PURE__ */ import_react23.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8L15 11H9L12 8Z",
    fill: color
  }))
});

// src/components/ChevronUp.tsx
var import_react24 = __toESM(require("react"));
var ChevronUp = (props) => /* @__PURE__ */ import_react24.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react24.default.createElement("path", {
    d: "M6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29288C11.6834 7.90238 12.3166 7.90238 12.7071 8.29288L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071Z",
    fill: color
  })
});

// src/components/ChevronUpDown.tsx
var import_react25 = __toESM(require("react"));
var ChevronUpDown = (props) => /* @__PURE__ */ import_react25.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react25.default.createElement("path", {
    d: "M14.205 10.195L11.7 7.69l-2.505 2.505a.7.7 0 0 1-.99-.99l3-3a.7.7 0 0 1 .99 0l3 3a.7.7 0 0 1-.99.99zm0 3.01a.7.7 0 1 1 .99.99l-3 3a.7.7 0 0 1-.99 0l-3-3a.7.7 0 1 1 .99-.99L11.7 15.71l2.505-2.505z",
    fill: color
  })
});

// src/components/ChevronUpMini.tsx
var import_react26 = __toESM(require("react"));
var ChevronUpMini = (props) => /* @__PURE__ */ import_react26.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react26.default.createElement("path", {
    d: "M8.19497 14.1949C7.92161 14.4682 7.47839 14.4682 7.20503 14.1949C6.93166 13.9215 6.93166 13.4783 7.20503 13.2049L11.205 9.20493C11.4784 8.93156 11.9216 8.93156 12.195 9.20493L16.195 13.2049C16.4683 13.4783 16.4683 13.9215 16.195 14.1949C15.9216 14.4682 15.4784 14.4682 15.205 14.1949L11.7 10.6899L8.19497 14.1949Z",
    fill: color
  })
});

// src/components/Cloud.tsx
var import_react27 = __toESM(require("react"));
var Cloud = (props) => /* @__PURE__ */ import_react27.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react27.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.5C2 16.5376 4.46243 19 7.5 19H17.5C19.9853 19 22 16.9853 22 14.5C22 12.5229 20.7249 10.8436 18.9523 10.2395C18.5785 7.28485 16.0561 5 13 5C10.7759 5 8.8344 6.21016 7.79811 8.00794C7.69941 8.00267 7.60002 8 7.5 8C4.46243 8 2 10.4624 2 13.5ZM17.5 17H7.5C5.567 17 4 15.433 4 13.5C4 11.567 5.567 10 7.5 10C7.56413 10 7.62795 10.0017 7.69144 10.0051C8.44366 10.0453 9.15465 9.65938 9.53085 9.00674C10.2414 7.77399 11.5522 7 13 7C15.02 7 16.7172 8.50686 16.9681 10.4905C17.064 11.2487 17.5837 11.8861 18.3072 12.1326C19.3108 12.4746 20 13.4216 20 14.5C20 15.8807 18.8807 17 17.5 17Z",
    fill: color
  })
});

// src/components/CloudDownload.tsx
var import_react28 = __toESM(require("react"));
var CloudDownload = (props) => /* @__PURE__ */ import_react28.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react28.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H15.5L17.5 17C18.8807 17 20 15.8807 20 14.5C20 13.4216 19.3108 12.4746 18.3072 12.1326C17.5837 11.8861 17.064 11.2487 16.9681 10.4905C16.7172 8.50686 15.02 7 13 7C11.5522 7 10.2414 7.77399 9.53085 9.00674C9.15465 9.65938 8.44366 10.0453 7.69144 10.0051C7.62795 10.0017 7.56413 10 7.5 10C5.567 10 4 11.567 4 13.5C4 15.0048 4.94967 16.2878 6.28239 16.7824L8.5 19H7.5ZM16 16L12 20L8 16H11V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V16H16Z",
    fill: color
  })
});

// src/components/CloudDownloadFilled.tsx
var import_react29 = __toESM(require("react"));
var CloudDownloadFilled = (props) => /* @__PURE__ */ import_react29.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react29.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H7.5ZM16 13L12 17L8 13H11V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V13H16Z",
    fill: color
  })
});

// src/components/CloudFilled.tsx
var import_react30 = __toESM(require("react"));
var CloudFilled = (props) => /* @__PURE__ */ import_react30.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react30.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H7.5Z",
    fill: color
  })
});

// src/components/CloudUpload.tsx
var import_react31 = __toESM(require("react"));
var CloudUpload = (props) => /* @__PURE__ */ import_react31.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react31.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19C4.46243 19 2 16.5376 2 13.5C2 10.4624 4.46243 8 7.5 8C7.60002 8 7.69941 8.00267 7.79811 8.00794C8.8344 6.21016 10.7759 5 13 5C16.0561 5 18.5785 7.28485 18.9523 10.2395C20.7249 10.8436 22 12.5229 22 14.5C22 16.9853 19.9853 19 17.5 19H14V17H17.5C18.8807 17 20 15.8807 20 14.5C20 13.4216 19.3108 12.4746 18.3072 12.1326C17.5837 11.8861 17.064 11.2487 16.9681 10.4905C16.7172 8.50686 15.02 7 13 7C11.5522 7 10.2414 7.77399 9.53085 9.00674C9.15465 9.65938 8.44366 10.0453 7.69144 10.0051C7.62795 10.0017 7.56413 10 7.5 10C5.567 10 4 11.567 4 13.5C4 15.433 5.567 17 7.5 17H10V19H7.5ZM8 14L12 10L16 14H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V14H8Z",
    fill: color
  })
});

// src/components/CloudUploadFilled.tsx
var import_react32 = __toESM(require("react"));
var CloudUploadFilled = (props) => /* @__PURE__ */ import_react32.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react32.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.5C2 16.5376 4.46243 19 7.5 19H17.5C19.9853 19 22 16.9853 22 14.5C22 12.5229 20.7249 10.8436 18.9523 10.2395C18.5785 7.28485 16.0561 5 13 5C10.7759 5 8.8344 6.21016 7.79811 8.00794C7.69941 8.00267 7.60002 8 7.5 8C4.46243 8 2 10.4624 2 13.5ZM13 16V13H16L12 9L8 13H11V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16Z",
    fill: color
  })
});

// src/components/Cog.tsx
var import_react33 = __toESM(require("react"));
var Cog = (props) => /* @__PURE__ */ import_react33.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react33.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V6C13 6.02774 12.9989 6.05523 12.9967 6.0824C14.0406 6.25693 14.9933 6.70103 15.7806 7.34069L16.4142 6.70711C16.8047 6.31658 17.4379 6.31658 17.8284 6.70711C18.219 7.09763 18.219 7.7308 17.8284 8.12132L17.1213 8.82843L17.1044 8.84491C17.5057 9.49266 17.7871 10.2225 17.9176 11.0033C17.9448 11.0011 17.9723 11 18 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H18C17.9723 13 17.9448 12.9989 17.9176 12.9967C17.762 13.9275 17.3921 14.7857 16.8603 15.5189C16.9545 15.5659 17.0428 15.6286 17.1213 15.7071L17.8284 16.4142C18.219 16.8047 18.219 17.4379 17.8284 17.8284C17.4379 18.219 16.8047 18.219 16.4142 17.8284L15.7071 17.1213C15.6286 17.0428 15.5659 16.9545 15.5189 16.8603C14.7857 17.3921 13.9275 17.762 12.9967 17.9176C12.9989 17.9448 13 17.9723 13 18V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V18C11 17.9723 11.0011 17.9448 11.0033 17.9176C10.2225 17.7871 9.49266 17.5057 8.84491 17.1044L8.82843 17.1213L8.12132 17.8284C7.7308 18.219 7.09763 18.219 6.70711 17.8284C6.31658 17.4379 6.31658 16.8047 6.70711 16.4142L7.34069 15.7806C6.70103 14.9933 6.25693 14.0406 6.0824 12.9967C6.05522 12.9989 6.02774 13 6 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H6C6.02774 11 6.05522 11.0011 6.0824 11.0033C6.23503 10.0904 6.59381 9.24728 7.10925 8.52347L6.70711 8.12132C6.31658 7.7308 6.31658 7.09763 6.70711 6.70711C7.09763 6.31658 7.7308 6.31658 8.12132 6.70711L8.52347 7.10925C9.24728 6.59381 10.0904 6.23503 11.0033 6.0824C11.0011 6.05523 11 6.02774 11 6V5ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
    fill: color
  })
});

// src/components/CogDouble.tsx
var import_react34 = __toESM(require("react"));
var CogDouble = (props) => /* @__PURE__ */ import_react34.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react34.default.createElement("path", {
    d: "M22.0817 14.0824H21.2345C21.1234 13.567 20.9187 13.0871 20.6421 12.6574L21.2432 12.0563C21.6011 11.6976 21.6011 11.1162 21.2432 10.7575C20.8846 10.3989 20.3031 10.3989 19.9445 10.7575L19.3434 11.3586C18.9136 11.0813 18.4338 10.8766 17.9183 10.7655V9.91833C17.9183 9.41162 17.5074 9 17 9C16.4926 9 16.0817 9.41162 16.0817 9.91833V10.7655C15.5662 10.8773 15.0864 11.082 14.6574 11.3586L14.0563 10.7575C13.6984 10.3989 13.1162 10.3989 12.7583 10.7575C12.3996 11.1162 12.3996 11.6976 12.7583 12.0563L13.3586 12.6566C13.0806 13.0864 12.8766 13.567 12.7648 14.0824H11.9183C11.4116 14.0824 11 14.4933 11 15.0007C11 15.5082 11.4109 15.9191 11.9183 15.9191H12.7648C12.8766 16.4345 13.0813 16.9143 13.3579 17.3441L12.7575 17.9445C12.3989 18.3031 12.3989 18.8846 12.7575 19.2432C12.9368 19.4225 13.1713 19.5118 13.4073 19.5118C13.6432 19.5118 13.877 19.4225 14.057 19.2432L14.6574 18.6421C15.0871 18.9194 15.567 19.1234 16.0824 19.2352V20.0817C16.0824 20.5884 16.4933 21 17.0007 21C17.5082 21 17.9191 20.5891 17.9191 20.0817V19.2352C18.4345 19.1241 18.9151 18.9187 19.3448 18.6421L19.9452 19.2425C20.1245 19.4218 20.359 19.5118 20.5949 19.5118C20.8294 19.5118 21.0646 19.4225 21.2439 19.2432C21.6025 18.8846 21.6025 18.3031 21.2446 17.9452L20.6436 17.3434C20.9209 16.9143 21.1249 16.4338 21.2359 15.9191H22.0817C22.5884 15.9191 23 15.5082 23 15.0007C23 14.4933 22.5884 14.0824 22.0817 14.0824ZM17.0007 17.4987C15.6229 17.4987 14.5027 16.3793 14.5013 15.0029C14.5027 13.6214 15.6229 12.502 17.0007 12.502C18.3779 12.502 19.498 13.6229 19.498 15.0007C19.498 16.3779 18.3779 17.4987 17.0007 17.4987ZM13.0817 8.0824C13.5884 8.0824 14 8.49328 14 9.00073C14 9.50817 13.5884 9.91906 13.0817 9.91906H12.2359C12.1249 10.4338 11.9209 10.9143 11.6436 11.3434L12.2446 11.9452C12.6025 12.3031 12.6025 12.8846 12.2439 13.2432C12.0646 13.4225 11.8294 13.5118 11.5949 13.5118C11.359 13.5118 11.1245 13.4218 10.9452 13.2425L10.3448 12.6421C9.91506 12.9187 9.43448 13.1241 8.91906 13.2352V14.0817C8.91906 14.5891 8.50817 15 8.00073 15C7.49328 15 7.0824 14.5884 7.0824 14.0817V13.2352C6.56697 13.1234 6.08711 12.9194 5.65735 12.6421L5.05699 13.2432C4.87695 13.4225 4.64319 13.5118 4.40726 13.5118C4.17132 13.5118 3.93684 13.4225 3.75753 13.2432C3.39891 12.8846 3.39891 12.3031 3.75753 11.9445L4.35789 11.3441C4.08131 10.9143 3.87659 10.4345 3.76479 9.91906H2.91833C2.41089 9.91906 2 9.50817 2 9.00073C2 8.49328 2.41162 8.0824 2.91833 8.0824H3.76479C3.87659 7.56697 4.08058 7.08639 4.35862 6.65662L3.75826 6.05626C3.39964 5.69764 3.39964 5.11615 3.75826 4.75753C4.11615 4.39891 4.69837 4.39891 5.05626 4.75753L5.65735 5.35862C6.08639 5.08203 6.56624 4.87731 7.08167 4.76552V3.91833C7.08167 3.41162 7.49256 3 8 3C8.50744 3 8.91833 3.41162 8.91833 3.91833V4.76552C9.43376 4.87659 9.91361 5.08131 10.3434 5.35862L10.9445 4.75753C11.3031 4.39891 11.8846 4.39891 12.2432 4.75753C12.6011 5.11615 12.6011 5.69764 12.2432 6.05626L11.6421 6.65735C11.9187 7.08711 12.1234 7.56697 12.2345 8.0824H13.0817ZM8.00073 11.4987C9.37786 11.4987 10.498 10.3779 10.498 9.00073C10.498 7.62287 9.37786 6.502 8.00073 6.502C6.62287 6.502 5.50272 7.62142 5.50127 9.0029C5.50272 10.3793 6.62287 11.4987 8.00073 11.4987Z",
    fill: color
  })
});

// src/components/Copy.tsx
var import_react35 = __toESM(require("react"));
var Copy = (props) => /* @__PURE__ */ import_react35.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react35.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3H18C19.1046 3 20 3.89543 20 5V15C20 16.1046 19.1046 17 18 17H16V19C16 20.1046 15.1046 21 14 21H6C4.89543 21 4 20.1046 4 19V9C4 7.89543 4.89543 7 6 7H8V5C8 3.89543 8.89543 3 10 3ZM16 15V9C16 7.89543 15.1046 7 14 7H10V5H18V15H16ZM7 14.5C6.72386 14.5 6.5 14.2761 6.5 14C6.5 13.7239 6.72386 13.5 7 13.5H9.5V11C9.5 10.7239 9.72386 10.5 10 10.5C10.2761 10.5 10.5 10.7239 10.5 11V13.5H13C13.2761 13.5 13.5 13.7239 13.5 14C13.5 14.2761 13.2761 14.5 13 14.5H10.5V17C10.5 17.2761 10.2761 17.5 10 17.5C9.72386 17.5 9.5 17.2761 9.5 17V14.5H7Z",
    fill: color
  })
});

// src/components/Cross.tsx
var import_react36 = __toESM(require("react"));
var Cross = (props) => /* @__PURE__ */ import_react36.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react36.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L10.5858 12L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70711C18.0976 7.31658 18.0976 6.68342 17.7071 6.29289C17.3166 5.90237 16.6834 5.90237 16.2929 6.29289L12 10.5858L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289Z",
    fill: color
  })
});

// src/components/CrossCircle.tsx
var import_react37 = __toESM(require("react"));
var CrossCircle = (props) => /* @__PURE__ */ import_react37.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react37.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.70711 16.7071L12 13.4142L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711C17.6499 7.7643 16.2357 6.35008 15.2929 7.29289L12 10.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929C6.35008 16.2357 7.7643 17.6499 8.70711 16.7071Z",
    fill: color
  })
});

// src/components/Documentation.tsx
var import_react38 = __toESM(require("react"));
var Documentation = (props) => /* @__PURE__ */ import_react38.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react38.default.createElement("path", {
    d: "M13 21V23H11V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73479 2.10536 3.48043 2.29289 3.2929C2.48043 3.10536 2.73478 3 3 3H9C9.56759 2.99933 10.1288 3.11976 10.6461 3.35325C11.1635 3.58674 11.625 3.92792 12 4.354C12.375 3.92792 12.8365 3.58674 13.3539 3.35325C13.8712 3.11976 14.4324 2.99933 15 3H21C21.2652 3 21.5196 3.10536 21.7071 3.2929C21.8946 3.48043 22 3.73479 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H13ZM20 19V5H15C14.4696 5 13.9609 5.21072 13.5858 5.58579C13.2107 5.96086 13 6.46957 13 7V19H20ZM11 19V7C11 6.46957 10.7893 5.96086 10.4142 5.58579C10.0391 5.21072 9.53043 5 9 5H4V19H11Z",
    fill: color
  })
});

// src/components/Download.tsx
var import_react39 = __toESM(require("react"));
var Download = (props) => /* @__PURE__ */ import_react39.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react39.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V11H17L12 16L7 11H11V5ZM7 19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18H8C7.44772 18 7 18.4477 7 19Z",
    fill: color
  })
});

// src/components/Draggable.tsx
var import_react40 = __toESM(require("react"));
var Draggable = (props) => /* @__PURE__ */ import_react40.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react40.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11H18C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9H6ZM6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15H18C18.5523 15 19 14.5523 19 14C19 13.4477 18.5523 13 18 13H6Z",
    fill: color
  })
});

// src/components/Duplicate.tsx
var import_react41 = __toESM(require("react"));
var Duplicate = (props) => /* @__PURE__ */ import_react41.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react41.default.createElement("path", {
    d: "M10 13v-2.6a.4.4 0 0 0-.4-.4h-.2a.4.4 0 0 0-.4.4V13H6.4a.4.4 0 0 0-.4.4v.2c0 .22.18.4.4.4H9v2.6c0 .22.18.4.4.4h.2a.4.4 0 0 0 .4-.4V14h2.6a.4.4 0 0 0 .4-.4v-.2a.4.4 0 0 0-.4-.4H10zm5 0h1.6a.4.4 0 0 0 .4-.4V6.4a.4.4 0 0 0-.4-.4h-6.2a.4.4 0 0 0-.4.4V8h3a2 2 0 0 1 2 2v3zm0 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h2V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2z",
    fill: color
  })
});

// src/components/EyeClose.tsx
var import_react42 = __toESM(require("react"));
var EyeClose = (props) => /* @__PURE__ */ import_react42.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react42.default.createElement("path", {
    d: "M5.666 8.798L3.4 6.53 4.531 5.4l14 14-1.131 1.131-3.277-3.276A8.425 8.425 0 0 1 3.965 11.75a8.412 8.412 0 0 1 1.701-2.952zm7.09 7.09l-1.392-1.392a2.604 2.604 0 0 1-1.928-1.93l-1.392-1.39a4 4 0 0 0 4.712 4.712zM8.057 6.926a8.425 8.425 0 0 1 11.909 4.824 8.439 8.439 0 0 1-2.969 4.116l-1.694-1.694A4 4 0 0 0 9.76 8.629L8.057 6.925zm2.725 2.724a2.6 2.6 0 0 1 3.5 3.5l-3.5-3.5z",
    fill: color
  })
});

// src/components/EyeOpen.tsx
var import_react43 = __toESM(require("react"));
var EyeOpen = (props) => /* @__PURE__ */ import_react43.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react43.default.createElement("path", {
    d: "M4 11.784a8.425 8.425 0 0 1 16 0 8.425 8.425 0 0 1-16 0zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-1.4a2.6 2.6 0 1 1 0-5.2 2.6 2.6 0 0 1 0 5.2z",
    fill: color
  })
});

// src/components/Feedback.tsx
var import_react44 = __toESM(require("react"));
var Feedback = (props) => /* @__PURE__ */ import_react44.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react44.default.createElement("path", {
    d: "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z",
    fill: color
  })
});

// src/components/File.tsx
var import_react45 = __toESM(require("react"));
var File = (props) => /* @__PURE__ */ import_react45.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react45.default.createElement("path", {
    d: "M8 5H14.5L18 8.5V17C18 18.1046 17.1046 19 16 19H8C6.89543 19 6 18.1046 6 17V7C6 5.89543 6.89543 5 8 5ZM14 5.5V9H17.5L14 5.5Z",
    fill: color
  })
});

// src/components/Filter.tsx
var import_react46 = __toESM(require("react"));
var Filter = (props) => /* @__PURE__ */ import_react46.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react46.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C8 5.44772 8.44772 5 9 5C9.55228 5 10 5.44772 10 6C10 6.55228 9.55228 7 9 7C8.44772 7 8 6.55228 8 6ZM6.17071 5H4.6C4.26863 5 4 5.26863 4 5.6V6.4C4 6.73137 4.26863 7 4.6 7H6.17071C6.58254 8.16519 7.69378 9 9 9C10.3062 9 11.4175 8.16519 11.8293 7H20.2C20.6418 7 21 6.64183 21 6.2V5.8C21 5.35817 20.6418 5 20.2 5H11.8293C11.4175 3.83481 10.3062 3 9 3C7.69378 3 6.58254 3.83481 6.17071 5ZM9 21C10.3062 21 11.4175 20.1652 11.8293 19H20.2C20.6418 19 21 18.6418 21 18.2V17.8C21 17.3582 20.6418 17 20.2 17H11.8293C11.4175 15.8348 10.3062 15 9 15C7.69378 15 6.58254 15.8348 6.17071 17H4.6C4.26863 17 4 17.2686 4 17.6V18.4C4 18.7314 4.26863 19 4.6 19H6.17071C6.58254 20.1652 7.69378 21 9 21ZM9 19C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17C9.55228 17 10 17.4477 10 18C10 18.5523 9.55228 19 9 19ZM13.1707 13H4.8C4.35817 13 4 12.6418 4 12.2V11.8C4 11.3582 4.35817 11 4.8 11H13.1707C13.5825 9.83481 14.6938 9 16 9C17.3062 9 18.4175 9.83481 18.8293 11H20.4C20.7314 11 21 11.2686 21 11.6V12.4C21 12.7314 20.7314 13 20.4 13H18.8293C18.4175 14.1652 17.3062 15 16 15C14.6938 15 13.5825 14.1652 13.1707 13ZM15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12Z",
    fill: color
  })
});

// src/components/HintFeedback.tsx
var import_react47 = __toESM(require("react"));
var HintFeedback = (props) => /* @__PURE__ */ import_react47.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react47.default.createElement(import_react47.default.Fragment, null, /* @__PURE__ */ import_react47.default.createElement("path", {
    opacity: "0.12",
    d: "M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23Z",
    fill: color
  }), /* @__PURE__ */ import_react47.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8322 12.8881V13.9231H11.2937V12.3566L12.5944 11.4336C12.7743 11.296 12.9142 11.1985 13.014 11.1289C13.0461 11.1065 13.0741 11.087 13.0979 11.0699C13.1958 11 13.3077 10.8881 13.4336 10.7483C13.6993 10.4685 13.7552 10.2028 13.7552 9.76923C13.7552 9.02797 13.2378 8.3986 12.2448 8.3986C11.1399 8.3986 10.4685 9.0979 10.4685 10.2587H9C9 9.23776 9.30769 8.44056 9.90909 7.86713C10.5105 7.29371 11.2937 7 12.2448 7C13.2098 7 13.965 7.26573 14.4965 7.7972C15.028 8.32867 15.2937 8.97203 15.2937 9.74126C15.2937 10.3427 15.0699 10.8881 14.8462 11.2378C14.7483 11.4056 14.5804 11.5874 14.3566 11.7832C14.1469 11.979 13.979 12.1189 13.8531 12.2028L13.3217 12.5524L12.8322 12.8881ZM12.8741 15.2797V17H11.2517V15.2797H12.8741Z",
    fill: color
  }))
});

// src/components/HintInner.tsx
var import_react48 = __toESM(require("react"));
var HintInner = (props) => /* @__PURE__ */ import_react48.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react48.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8322 12.8881V13.9231H11.2937V12.3566L12.5944 11.4336C12.7743 11.296 12.9142 11.1985 13.014 11.1289C13.0461 11.1065 13.0741 11.087 13.0979 11.0699C13.1958 11 13.3077 10.8881 13.4336 10.7483C13.6993 10.4685 13.7552 10.2028 13.7552 9.76923C13.7552 9.02797 13.2378 8.3986 12.2448 8.3986C11.1399 8.3986 10.4685 9.0979 10.4685 10.2587H9C9 9.23776 9.30769 8.44056 9.90909 7.86713C10.5105 7.29371 11.2937 7 12.2448 7C13.2098 7 13.965 7.26573 14.4965 7.7972C15.028 8.32867 15.2937 8.97203 15.2937 9.74126C15.2937 10.3427 15.0699 10.8881 14.8462 11.2378C14.7483 11.4056 14.5804 11.5874 14.3566 11.7832C14.1469 11.979 13.979 12.1189 13.8531 12.2028L13.3217 12.5524L12.8322 12.8881ZM12.8741 15.2797V17H11.2517V15.2797H12.8741Z",
    fill: color
  })
});

// src/components/Key.tsx
var import_react49 = __toESM(require("react"));
var Key = (props) => /* @__PURE__ */ import_react49.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react49.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60349 13.4853L8.18928 12.0711C7.40823 11.29 7.40823 10.0237 8.18928 9.24264L13.139 4.29289C13.5295 3.90237 14.1627 3.90237 14.5532 4.29289L20.2101 9.94975C20.6006 10.3403 20.6006 10.9734 20.2101 11.364L15.2603 16.3137C14.4793 17.0948 13.213 17.0948 12.4319 16.3137L11.0177 14.8995L5.41421 20.503L4 19.0888L9.60349 13.4853ZM17.0988 9.6669L14.8361 7.40416C14.6799 7.24795 14.4266 7.24795 14.2704 7.40416L13.4219 8.25269C13.2657 8.4089 13.2657 8.66217 13.4219 8.81838L15.6846 11.0811C15.8408 11.2373 16.0941 11.2373 16.2503 11.0811L17.0988 10.2326C17.255 10.0764 17.255 9.82311 17.0988 9.6669Z",
    fill: color
  })
});

// src/components/ListDot.tsx
var import_react50 = __toESM(require("react"));
var ListDot = (props) => /* @__PURE__ */ import_react50.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react50.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6 6C4.26863 6 4 6.26863 4 6.6V7.4C4 7.73137 4.26863 8 4.6 8H7V6H4.6ZM19.2 6H9V8H19.2C19.6418 8 20 7.64183 20 7.2V6.8C20 6.35817 19.6418 6 19.2 6ZM19.2 16H9V18H19.2C19.6418 18 20 17.6418 20 17.2V16.8C20 16.3582 19.6418 16 19.2 16ZM9 11H19.2C19.6418 11 20 11.3582 20 11.8V12.2C20 12.6418 19.6418 13 19.2 13H9V11ZM4 16.6C4 16.2686 4.26863 16 4.6 16H7V18H4.6C4.26863 18 4 17.7314 4 17.4V16.6ZM4.6 11C4.26863 11 4 11.2686 4 11.6V12.4C4 12.7314 4.26863 13 4.6 13H7V11H4.6Z",
    fill: color
  })
});

// src/components/Lock.tsx
var import_react51 = __toESM(require("react"));
var Lock = (props) => /* @__PURE__ */ import_react51.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react51.default.createElement("path", {
    d: "M8.4 11H15.6V9.66667C15.6 7.88495 14.009 6.4 12 6.4C9.99101 6.4 8.4 7.88495 8.4 9.66667V11ZM17 11C17.5523 11 18 11.4477 18 12V17C18 18.1046 17.1046 19 16 19H8C6.89543 19 6 18.1046 6 17V12C6 11.4477 6.44772 11 7 11V9.66667C7 7.08934 9.23858 5 12 5C14.7614 5 17 7.08934 17 9.66667V11Z",
    fill: color
  })
});

// src/components/Logout.tsx
var import_react52 = __toESM(require("react"));
var Logout = (props) => /* @__PURE__ */ import_react52.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react52.default.createElement("path", {
    d: "M8.17221 11H13.9002C14.1654 11 14.4198 11.1054 14.6073 11.2929C14.7949 11.4804 14.9002 11.7348 14.9002 12C14.9002 12.2652 14.7949 12.5196 14.6073 12.7071C14.4198 12.8946 14.1654 13 13.9002 13H8.17221L9.53521 14.364C9.62363 14.4464 9.69455 14.5458 9.74374 14.6562C9.79294 14.7666 9.81939 14.8857 9.82152 15.0066C9.82365 15.1274 9.80142 15.2475 9.75616 15.3595C9.71089 15.4716 9.64352 15.5734 9.55805 15.6588C9.47259 15.7443 9.37079 15.8117 9.25873 15.8569C9.14666 15.9022 9.02662 15.9244 8.90578 15.9223C8.78494 15.9202 8.66576 15.8937 8.55536 15.8445C8.44496 15.7953 8.3456 15.7244 8.26321 15.636L5.26321 12.636C5.09467 12.4672 5 12.2385 5 12C5 11.7615 5.09467 11.5328 5.26321 11.364L8.26321 8.364C8.3456 8.27558 8.44496 8.20465 8.55536 8.15546C8.66576 8.10627 8.78494 8.07982 8.90578 8.07769C9.02662 8.07556 9.14666 8.09779 9.25873 8.14305C9.37079 8.18832 9.47259 8.25569 9.55805 8.34115C9.64352 8.42662 9.71089 8.52842 9.75616 8.64048C9.80142 8.75255 9.82365 8.87258 9.82152 8.99343C9.81939 9.11427 9.79294 9.23345 9.74374 9.34385C9.69455 9.45424 9.62363 9.55361 9.53521 9.636L8.17221 11ZM10.9002 8V6H16.9002C17.4306 6 17.9393 6.21071 18.3144 6.58579C18.6895 6.96086 18.9002 7.46957 18.9002 8V16C18.9002 16.5304 18.6895 17.0391 18.3144 17.4142C17.9393 17.7893 17.4306 18 16.9002 18H10.9002V16H16.9002V8H10.9002Z",
    fill: color
  })
});

// src/components/Mail.tsx
var import_react53 = __toESM(require("react"));
var Mail = (props) => /* @__PURE__ */ import_react53.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react53.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7H19V17H5L5 7ZM3 7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V7ZM7.62473 8.21917C7.19347 7.87416 6.56418 7.94408 6.21917 8.37534C5.87416 8.8066 5.94408 9.4359 6.37534 9.78091L11.3753 13.7809C11.7406 14.0731 12.2595 14.0731 12.6247 13.7809L17.6247 9.78091C18.056 9.4359 18.1259 8.8066 17.7809 8.37534C17.4359 7.94408 16.8066 7.87416 16.3753 8.21917L12 11.7194L7.62473 8.21917Z",
    fill: color
  })
});

// src/components/Menu.tsx
var import_react54 = __toESM(require("react"));
var Menu = (props) => /* @__PURE__ */ import_react54.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react54.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.8C4 5.35817 4.35817 5 4.8 5H20.2C20.6418 5 21 5.35817 21 5.8V6.2C21 6.64183 20.6418 7 20.2 7H4.8C4.35817 7 4 6.64183 4 6.2V5.8ZM4 11.8C4 11.3582 4.35817 11 4.8 11H20.2C20.6418 11 21 11.3582 21 11.8V12.2C21 12.6418 20.6418 13 20.2 13H4.8C4.35817 13 4 12.6418 4 12.2V11.8ZM4.8 17C4.35817 17 4 17.3582 4 17.8V18.2C4 18.6418 4.35817 19 4.8 19H20.2C20.6418 19 21 18.6418 21 18.2V17.8C21 17.3582 20.6418 17 20.2 17H4.8Z",
    fill: color
  })
});

// src/components/Message.tsx
var import_react55 = __toESM(require("react"));
var Message = (props) => /* @__PURE__ */ import_react55.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react55.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.515 14.9453L21 9.63554V18.246C21 19.088 21 20 19.25 20L4.75 20C3 20 3 19.1543 3 18.246L3 9.63554L10.485 14.9453C11.43 15.615 12.57 15.615 13.515 14.9453ZM3 7.59453C3 7.59453 3 6 4.75 6L19.25 6C21 6 21 7.59453 21 7.59453L13.515 12.9043C12.7575 13.4385 12.3787 13.7056 12 13.7056C11.6213 13.7056 11.2425 13.4385 10.485 12.9043L3 7.59453Z",
    fill: color
  })
});

// src/components/Minimize.tsx
var import_react56 = __toESM(require("react"));
var Minimize = (props) => /* @__PURE__ */ import_react56.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react56.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5H18C19.1046 5 20 5.89543 20 7V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V7C4 5.89543 4.89543 5 6 5ZM6 7V17H18V7H6ZM16 13H8V15H16V13Z",
    fill: color
  })
});

// src/components/Minus.tsx
var import_react57 = __toESM(require("react"));
var Minus = (props) => /* @__PURE__ */ import_react57.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react57.default.createElement("path", {
    d: "M6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6Z",
    fill: color
  })
});

// src/components/Module.tsx
var import_react58 = __toESM(require("react"));
var Module = (props) => /* @__PURE__ */ import_react58.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react58.default.createElement("path", {
    d: "M5 9H19C19.5523 9 20 9.44772 20 10V17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17V10C4 9.44772 4.44772 9 5 9ZM6 11V16H18V11H6ZM14.4 6H17.6C17.8209 6 18 6.17909 18 6.4V8H14V6.4C14 6.17909 14.1791 6 14.4 6ZM6.4 6H9.6C9.82091 6 10 6.17909 10 6.4V8H6V6.4C6 6.17909 6.17909 6 6.4 6Z",
    fill: color
  })
});

// src/components/More.tsx
var import_react59 = __toESM(require("react"));
var More = (props) => /* @__PURE__ */ import_react59.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react59.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z",
    fill: color
  })
});

// src/components/Move.tsx
var import_react60 = __toESM(require("react"));
var Move = (props) => /* @__PURE__ */ import_react60.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react60.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3H18C19.1046 3 20 3.89543 20 5V15C20 16.1046 19.1046 17 18 17H16V19C16 20.1046 15.1046 21 14 21H6C4.89543 21 4 20.1046 4 19V9C4 7.89543 4.89543 7 6 7H8V5C8 3.89543 8.89543 3 10 3ZM16 15V9C16 7.89543 15.1046 7 14 7H10V5H18V15H16ZM7.34109 16.3437C7.1451 16.5382 6.82852 16.537 6.63398 16.341C6.43945 16.1451 6.44063 15.8285 6.63662 15.6339L11.8089 10.5H9C8.72386 10.5 8.5 10.2761 8.5 10C8.5 9.72386 8.72386 9.5 9 9.5H13C13.1412 9.5 13.2688 9.55856 13.3597 9.65273C13.3618 9.65478 13.3639 9.65686 13.366 9.65896C13.4896 9.78351 13.5342 9.95678 13.5 10.1165V14C13.5 14.2761 13.2761 14.5 13 14.5C12.7239 14.5 12.5 14.2761 12.5 14V11.223L7.34109 16.3437Z",
    fill: color
  })
});

// src/components/NewTab.tsx
var import_react61 = __toESM(require("react"));
var NewTab = (props) => /* @__PURE__ */ import_react61.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react61.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18C17.1046 18 18 17.1046 18 16V12H16V16H8V8H12V6H8C6.89543 6 6 6.89543 6 8V16C6 17.1046 6.89543 18 8 18H16ZM15.995 8.99497L12.495 12.495L11.505 11.505L15.005 8.00503L13 6H18V11L15.995 8.99497Z",
    fill: color
  })
});

// src/components/Pencil.tsx
var import_react62 = __toESM(require("react"));
var Pencil = (props) => /* @__PURE__ */ import_react62.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react62.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.58579L15 6.58579L16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289L19.2929 6.87868C19.6834 7.2692 19.6834 7.90237 19.2929 8.29289L18 9.58579ZM5 19.5858L8.5 19.0858L17 10.5858L14 7.58579L5.5 16.0858L5 19.5858Z",
    fill: color
  })
});

// src/components/Pin.tsx
var import_react63 = __toESM(require("react"));
var Pin = (props) => /* @__PURE__ */ import_react63.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react63.default.createElement("path", {
    d: "M4.55235 11.8014L7.77017 15.021L4.0573 19.5916C3.96729 19.6817 3.98979 19.8393 4.0798 19.9293C4.16981 20.0194 4.30482 20.0194 4.41734 19.9519L8.96279 16.2369L12.1806 19.4565C12.4281 19.7042 12.7882 19.7717 13.1257 19.6592C13.4632 19.5466 13.6883 19.2314 13.7108 18.8936C13.8008 17.993 13.5082 16.8898 12.9007 15.764L16.7261 10.9908C17.5136 11.3961 18.3912 11.5762 19.2688 11.5087C19.8989 11.4186 20.2364 10.6306 19.8089 10.2028L13.8008 4.19123C13.3732 3.76344 12.5857 4.10117 12.4956 4.7316C12.4281 5.60969 12.5857 6.48778 13.0132 7.27581L8.24272 11.1034C7.11761 10.4955 6.015 10.2253 5.11491 10.2928C4.77737 10.3154 4.46234 10.5405 4.34983 10.8782C4.21481 11.1935 4.30482 11.5537 4.55235 11.8014Z",
    fill: color
  })
});

// src/components/Plus.tsx
var import_react64 = __toESM(require("react"));
var Plus = (props) => /* @__PURE__ */ import_react64.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react64.default.createElement("path", {
    d: "M13 13v6.2a.8.8 0 0 1-.8.8h-.4a.8.8 0 0 1-.8-.8V13H4.8a.8.8 0 0 1-.8-.8v-.4a.8.8 0 0 1 .8-.8H11V4.8a.8.8 0 0 1 .8-.8h.4a.8.8 0 0 1 .8.8V11h6.2a.8.8 0 0 1 .8.8v.4a.8.8 0 0 1-.8.8H13z",
    fill: color
  })
});

// src/components/PlusCircle.tsx
var import_react65 = __toESM(require("react"));
var PlusCircle = (props) => /* @__PURE__ */ import_react65.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react65.default.createElement("path", {
    d: "M11 13v4.243a1 1 0 1 0 2 0V13h4.243a1 1 0 1 0 0-2H13V6.757a1 1 0 1 0-2 0V11H6.757a1 1 0 1 0 0 2H11zm-9-1C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z",
    fill: color
  })
});

// src/components/PlusFolder.tsx
var import_react66 = __toESM(require("react"));
var PlusFolder = (props) => /* @__PURE__ */ import_react66.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react66.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.295 13.76V12h-2.704V9.38H13.82V12h-2.705v1.76h2.705v2.62h1.774v-2.62h2.705-.003zm.932-7c.504 0 .926.173 1.265.515.34.342.508.758.508 1.247v8.72c0 .488-.17.903-.508 1.246a1.71 1.71 0 0 1-1.265.513H4.775a1.71 1.71 0 0 1-1.266-.513A1.705 1.705 0 0 1 3 17.24V6.76c0-.49.17-.904.51-1.247A1.71 1.71 0 0 1 4.774 5h5.41L12 6.76h7.227z",
    fill: color
  })
});

// src/components/PowerOff.tsx
var import_react67 = __toESM(require("react"));
var PowerOff = (props) => /* @__PURE__ */ import_react67.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react67.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C12.5523 12 13 11.5523 13 11V4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V11C11 11.5523 11.4477 12 12 12ZM18.2 12C18.2 10.2879 17.506 8.73792 16.3841 7.61594L17.6569 6.34315C19.1046 7.79086 20 9.79086 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.79086 4.89543 7.79086 6.34315 6.34315L7.61594 7.61594C6.49396 8.73792 5.8 10.2879 5.8 12C5.8 15.4242 8.57583 18.2 12 18.2C15.4242 18.2 18.2 15.4242 18.2 12Z",
    fill: color
  })
});

// src/components/Profile.tsx
var import_react68 = __toESM(require("react"));
var Profile = (props) => /* @__PURE__ */ import_react68.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react68.default.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM7.013 18.256C8.42855 19.3877 10.1877 20.0029 12 20C13.97 20 15.773 19.288 17.167 18.108C16.5157 17.4397 15.7371 16.9089 14.877 16.5468C14.017 16.1847 13.0931 15.9988 12.16 16C11.1926 15.9989 10.2355 16.1989 9.34947 16.5872C8.46343 16.9756 7.66778 17.5439 7.013 18.256ZM5.616 16.82C6.45645 15.9281 7.47067 15.2177 8.59614 14.7327C9.72161 14.2477 10.9345 13.9984 12.16 14C13.3417 13.9985 14.512 14.2304 15.6037 14.6824C16.6955 15.1344 17.6873 15.7976 18.522 16.634C19.3781 15.4291 19.8836 14.0106 19.9826 12.5359C20.0815 11.0612 19.77 9.58789 19.0825 8.27946C18.395 6.97102 17.3585 5.87862 16.088 5.12345C14.8174 4.36827 13.3625 3.97984 11.8846 4.00125C10.4067 4.02267 8.96366 4.45308 7.71552 5.24476C6.46738 6.03643 5.46296 7.1584 4.81369 8.4862C4.16442 9.814 3.89569 11.2957 4.03732 12.7669C4.17894 14.2382 4.72537 15.6414 5.616 16.821V16.82ZM12 13C10.9391 13 9.92172 12.5786 9.17157 11.8284C8.42143 11.0783 8 10.0609 8 9C8 7.93913 8.42143 6.92172 9.17157 6.17157C9.92172 5.42143 10.9391 5 12 5C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13ZM12 11C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7C11.4696 7 10.9609 7.21071 10.5858 7.58579C10.2107 7.96086 10 8.46957 10 9C10 9.53043 10.2107 10.0391 10.5858 10.4142C10.9609 10.7893 11.4696 11 12 11Z",
    fill: color
  })
});

// src/components/ResizeAngle.tsx
var import_react69 = __toESM(require("react"));
var ResizeAngle = (props) => /* @__PURE__ */ import_react69.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react69.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6537 12.3463C20.4625 12.1551 20.1526 12.1551 19.9614 12.3463L12.346 19.9616C12.1548 20.1528 12.1548 20.4628 12.346 20.654C12.5372 20.8451 12.8472 20.8451 13.0383 20.654L20.6537 13.0386C20.8449 12.8474 20.8449 12.5374 20.6537 12.3463ZM20.5349 16.3813C20.3438 16.1902 20.0338 16.1902 19.8426 16.3813L16.3811 19.8429C16.1899 20.034 16.1899 20.344 16.3811 20.5352C16.5723 20.7263 16.8822 20.7263 17.0734 20.5352L20.5349 17.0736C20.7261 16.8825 20.7261 16.5725 20.5349 16.3813Z",
    fill: color
  })
});

// src/components/Search.tsx
var import_react70 = __toESM(require("react"));
var Search = (props) => /* @__PURE__ */ import_react70.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react70.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 11.2958 15.5892 12.4957 14.8907 13.4765L18.9667 17.5525C19.3572 17.943 19.3572 18.5762 18.9667 18.9667C18.5762 19.3572 17.943 19.3572 17.5525 18.9667L13.4765 14.8907C12.4957 15.5892 11.2958 16 10 16ZM10 14.6C12.5405 14.6 14.6 12.5405 14.6 10C14.6 7.45949 12.5405 5.4 10 5.4C7.45949 5.4 5.4 7.45949 5.4 10C5.4 12.5405 7.45949 14.6 10 14.6Z",
    fill: color
  })
});

// src/components/Share.tsx
var import_react71 = __toESM(require("react"));
var Share = (props) => /* @__PURE__ */ import_react71.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react71.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.901 17.093L7.906 12.642C7.961 12.436 8 12.224 8 12C8 11.776 7.961 11.564 7.906 11.358L14.901 6.907C15.335 7.271 15.888 7.5 16.5 7.5C17.881 7.5 19 6.381 19 5C19 3.619 17.881 2.5 16.5 2.5C15.119 2.5 14 3.619 14 5C14 5.224 14.039 5.436 14.094 5.642L7.099 10.093C6.665 9.729 6.112 9.5 5.5 9.5C4.119 9.5 3 10.619 3 12C3 13.381 4.119 14.5 5.5 14.5C6.112 14.5 6.665 14.271 7.099 13.907L14.094 18.358C14.039 18.564 14 18.776 14 19C14 20.381 15.119 21.5 16.5 21.5C17.881 21.5 19 20.381 19 19C19 17.619 17.881 16.5 16.5 16.5C15.888 16.5 15.335 16.729 14.901 17.093Z",
    fill: color
  })
});

// src/components/Spinner.tsx
var import_react72 = __toESM(require("react"));
var Spinner = (props) => /* @__PURE__ */ import_react72.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react72.default.createElement("path", {
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C14.2013 4 16.1949 4.88907 17.6414 6.32771L16.231 7.74575C15.1127 6.63355 13.609 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12H20Z",
    fill: color
  })
});

// src/components/Star.tsx
var import_react73 = __toESM(require("react"));
var Star = (props) => /* @__PURE__ */ import_react73.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react73.default.createElement("path", {
    d: "M11.1179 4.61457C11.4086 3.79514 12.5914 3.79514 12.8821 4.61457L14.4152 8.93603L19.0835 9.02924C19.9687 9.04692 20.3342 10.1491 19.6287 10.6732L15.9078 13.4372L17.2599 17.8163C17.5163 18.6466 16.5595 19.3278 15.8327 18.8323L12 16.2191L8.16729 18.8323C7.44054 19.3278 6.48368 18.6466 6.74007 17.8163L8.09219 13.4372L4.37133 10.6732C3.66578 10.1491 4.03126 9.04692 4.91648 9.02924L9.58484 8.93603L11.1179 4.61457Z",
    fill: color
  })
});

// src/components/SuccessColorful.tsx
var import_react74 = __toESM(require("react"));
var SuccessColorful = (props) => /* @__PURE__ */ import_react74.default.createElement(IconBase, {
  ...props,
  renderPath: () => /* @__PURE__ */ import_react74.default.createElement(import_react74.default.Fragment, null, /* @__PURE__ */ import_react74.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /* @__PURE__ */ import_react74.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 -1.74845e-06 12 -1.74845e-06C5.37258 -1.74845e-06 1.74846e-06 5.37258 1.74846e-06 12C1.74846e-06 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear)"
  }), /* @__PURE__ */ import_react74.default.createElement("path", {
    d: "M16.0705 7.98109C16.3018 7.74386 16.6817 7.73909 16.9189 7.97045C17.1562 8.20181 17.1609 8.58168 16.9296 8.81891L10.7707 15.1189C10.5199 15.3762 10.1007 15.3567 9.87469 15.0773L7.93351 12.6773C7.72512 12.4197 7.76505 12.0419 8.0227 11.8335C8.28034 11.6251 8.65814 11.665 8.86653 11.9227L10.3831 13.1977L16.0705 7.98109Z",
    fill: "white"
  })), /* @__PURE__ */ import_react74.default.createElement("defs", null, /* @__PURE__ */ import_react74.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "1.74846e-06",
    y1: "24",
    x2: "24",
    y2: "-1.74845e-06",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ import_react74.default.createElement("stop", {
    stopColor: "#00BD78"
  }), /* @__PURE__ */ import_react74.default.createElement("stop", {
    offset: "1",
    stopColor: "#00E994"
  })), /* @__PURE__ */ import_react74.default.createElement("clipPath", {
    id: "clip0"
  }, /* @__PURE__ */ import_react74.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))
});

// src/components/Switcher.tsx
var import_react75 = __toESM(require("react"));
var Switcher = (props) => /* @__PURE__ */ import_react75.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react75.default.createElement("path", {
    d: "M6.75 2.5C7.30812 2.5 7.86077 2.60993 8.37641 2.82351C8.89204 3.03709 9.36056 3.35015 9.75521 3.7448C10.1499 4.13945 10.4629 4.60796 10.6765 5.1236C10.8901 5.63923 11 6.19188 11 6.75V11H6.75C5.62283 11 4.54183 10.5522 3.7448 9.7552C2.94777 8.95817 2.5 7.87717 2.5 6.75C2.5 5.62283 2.94777 4.54183 3.7448 3.7448C4.54183 2.94777 5.62283 2.5 6.75 2.5ZM9 9V6.75C9 6.30499 8.86804 5.86998 8.62081 5.49997C8.37358 5.12996 8.02217 4.84157 7.61104 4.67127C7.19991 4.50097 6.74751 4.45642 6.31105 4.54323C5.87459 4.63005 5.47368 4.84434 5.15901 5.15901C4.84434 5.47368 4.63005 5.87459 4.54323 6.31105C4.45642 6.7475 4.50098 7.1999 4.67127 7.61104C4.84157 8.02217 5.12996 8.37357 5.49997 8.62081C5.86998 8.86804 6.30499 9 6.75 9H9ZM6.75 13H11V17.25C11 18.0906 10.7507 18.9123 10.2837 19.6112C9.81675 20.3101 9.15299 20.8548 8.37641 21.1765C7.59982 21.4982 6.74529 21.5823 5.92087 21.4183C5.09645 21.2543 4.33917 20.8496 3.7448 20.2552C3.15042 19.6608 2.74565 18.9036 2.58166 18.0791C2.41768 17.2547 2.50184 16.4002 2.82351 15.6236C3.14519 14.847 3.68992 14.1833 4.38883 13.7163C5.08774 13.2493 5.90943 13 6.75 13ZM6.75 15C6.30499 15 5.86998 15.132 5.49997 15.3792C5.12996 15.6264 4.84157 15.9778 4.67127 16.389C4.50098 16.8001 4.45642 17.2525 4.54323 17.689C4.63005 18.1254 4.84434 18.5263 5.15901 18.841C5.47368 19.1557 5.87459 19.3699 6.31105 19.4568C6.74751 19.5436 7.19991 19.499 7.61104 19.3287C8.02217 19.1584 8.37358 18.87 8.62081 18.5C8.86804 18.13 9 17.695 9 17.25V15H6.75ZM17.25 2.5C18.3772 2.5 19.4582 2.94777 20.2552 3.7448C21.0522 4.54183 21.5 5.62283 21.5 6.75C21.5 7.87717 21.0522 8.95817 20.2552 9.7552C19.4582 10.5522 18.3772 11 17.25 11H13V6.75C13 5.62283 13.4478 4.54183 14.2448 3.7448C15.0418 2.94777 16.1228 2.5 17.25 2.5ZM17.25 9C17.695 9 18.13 8.86804 18.5 8.62081C18.87 8.37357 19.1584 8.02217 19.3287 7.61104C19.499 7.1999 19.5436 6.7475 19.4568 6.31105C19.37 5.87459 19.1557 5.47368 18.841 5.15901C18.5263 4.84434 18.1254 4.63005 17.689 4.54323C17.2525 4.45642 16.8001 4.50097 16.389 4.67127C15.9778 4.84157 15.6264 5.12996 15.3792 5.49997C15.132 5.86998 15 6.30499 15 6.75V9H17.25ZM13 13H17.25C18.0906 13 18.9123 13.2493 19.6112 13.7163C20.3101 14.1833 20.8548 14.847 21.1765 15.6236C21.4982 16.4002 21.5823 17.2547 21.4183 18.0791C21.2544 18.9036 20.8496 19.6608 20.2552 20.2552C19.6608 20.8496 18.9036 21.2543 18.0791 21.4183C17.2547 21.5823 16.4002 21.4982 15.6236 21.1765C14.847 20.8548 14.1833 20.3101 13.7163 19.6112C13.2493 18.9123 13 18.0906 13 17.25V13ZM15 15V17.25C15 17.695 15.132 18.13 15.3792 18.5C15.6264 18.87 15.9778 19.1584 16.389 19.3287C16.8001 19.499 17.2525 19.5436 17.689 19.4568C18.1254 19.3699 18.5263 19.1557 18.841 18.841C19.1557 18.5263 19.37 18.1254 19.4568 17.689C19.5436 17.2525 19.499 16.8001 19.3287 16.389C19.1584 15.9778 18.87 15.6264 18.5 15.3792C18.13 15.132 17.695 15 17.25 15H15Z",
    fill: color
  })
});

// src/components/Ticket.tsx
var import_react76 = __toESM(require("react"));
var Ticket = (props) => /* @__PURE__ */ import_react76.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react76.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C3.89543 6 3 6.89543 3 8V10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H5ZM12.6951 13.5385V12.7105L13.0867 12.442L13.5119 12.1622C13.6126 12.0951 13.7469 11.9832 13.9147 11.8266C14.0937 11.6699 14.228 11.5245 14.3063 11.3902C14.4853 11.1105 14.6643 10.6741 14.6643 10.193C14.6643 9.57762 14.4517 9.06294 14.0266 8.63776C13.6014 8.21259 12.9972 8 12.2252 8C11.4643 8 10.8378 8.23497 10.3566 8.69371C9.87552 9.15245 9.62937 9.79021 9.62937 10.607H10.8042C10.8042 9.67832 11.3413 9.11888 12.2252 9.11888C13.0196 9.11888 13.4336 9.62238 13.4336 10.2154C13.4336 10.5622 13.3888 10.7748 13.1762 10.9986C13.0755 11.1105 12.986 11.2 12.9077 11.2559C12.8886 11.2696 12.8663 11.2852 12.8406 11.3031L12.8406 11.3031L12.8405 11.3031C12.7607 11.3588 12.6488 11.4368 12.5049 11.5469L11.4643 12.2853V13.5385H12.6951ZM12.7287 14.6238V16H11.4308V14.6238H12.7287Z",
    fill: color
  })
});

// src/components/Tile.tsx
var import_react77 = __toESM(require("react"));
var Tile = (props) => /* @__PURE__ */ import_react77.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react77.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C5.44772 5 5 5.44772 5 6V10C5 10.5523 5.44772 11 6 11H10C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5H6ZM6 13C5.44772 13 5 13.4477 5 14V18C5 18.5523 5.44772 19 6 19H10C10.5523 19 11 18.5523 11 18V14C11 13.4477 10.5523 13 10 13H6ZM13 6C13 5.44772 13.4477 5 14 5H18C18.5523 5 19 5.44772 19 6V10C19 10.5523 18.5523 11 18 11H14C13.4477 11 13 10.5523 13 10V6ZM14 13C13.4477 13 13 13.4477 13 14V18C13 18.5523 13.4477 19 14 19H18C18.5523 19 19 18.5523 19 18V14C19 13.4477 18.5523 13 18 13H14Z",
    fill: color
  })
});

// src/components/Transaction.tsx
var import_react78 = __toESM(require("react"));
var Transaction = (props) => /* @__PURE__ */ import_react78.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react78.default.createElement("path", {
    d: "M14 11V9L17 12L14 15V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H14Z",
    fill: color
  })
});

// src/components/TransactionDouble.tsx
var import_react79 = __toESM(require("react"));
var TransactionDouble = (props) => /* @__PURE__ */ import_react79.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react79.default.createElement("path", {
    d: "M15 11V13L12 10L15 7V9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H15ZM9 13V11L12 14L9 17V15H3C2.44772 15 2 14.5523 2 14C2 13.4477 2.44772 13 3 13H9Z",
    fill: color
  })
});

// src/components/Trash.tsx
var import_react80 = __toESM(require("react"));
var Trash = (props) => /* @__PURE__ */ import_react80.default.createElement(IconBase, {
  ...props,
  renderPath: (color) => /* @__PURE__ */ import_react80.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2929 5.29289C14.1054 5.10536 13.851 5 13.5858 5H10.4142C10.149 5 9.89464 5.10536 9.70711 5.29289L9 6H7C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H17C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6H15L14.2929 5.29289ZM8 20C7.44772 20 7 19.5523 7 19V9H17V19C17 19.5523 16.5523 20 16 20H8Z",
    fill: color
  })
});

// src/hooks/useIsXsollaIcon.ts
var import_react81 = require("react");
var useIsXsollaIcon = (icon) => {
  return (0, import_react81.useMemo)(() => {
    var _a;
    return icon && ((_a = icon({})) == null ? void 0 : _a.type.displayName) === "IconBase" || false;
  }, [icon]);
};
